<template>
  <div id="user-edit-tab-info">
    <div class="vx-row">
      <div class="vx-col md:w-1/3 w-full">
        <!-- COMPANY / PERSON : affichage et SAGA seulement. L'e-factura ne le lit
             PAS (Chady, 2026-10-29) : un CUI / TVA / J encodé = société, rien =
             personne physique (13 zéros). D'où l'avertissement CuiNotice ci-dessous. -->
        <vs-switch
          color="dark"
          icon-pack="feather"
          vs-icon-on="icon-home"
          vs-icon-off="icon-user"
          v-model="data_local.iscompany"
        >
          <span slot="on">COMPANY</span>
          <span slot="off">PERSON</span>
        </vs-switch>

        <div>
          <div class="vx-row">
            <div class="vx-col md:w-1/2 w-full">
              <vs-input class="w-full mt-4" label="Name *" v-model="data_local.company_name" v-validate="'required'"
                name="name" />
              <span class="text-danger text-sm" v-show="errors.has('name')">{{
                errors.first("name")
              }}</span>
            </div>
            <div class="vx-col md:w-1/4 w-full">
              <vs-switch class="w-full mt-12" color="primary" icon-pack="feather" vs-icon-on="icon-yes"
                vs-icon-off="icon-no" v-model="data_local.isreseller">
                <span slot="on">Reseller</span>
                <span slot="off">Not Reseller</span>
              </vs-switch>
            </div>
            <div class="vx-col md:w-1/4 w-full" v-if="data_local.isreseller">
              <vs-switch class="w-full mt-12" color="primary" icon-pack="feather" vs-icon-on="icon-yes"
                vs-icon-off="icon-no" v-model="data_local.isbroker">
                <span slot="on">Broker</span>
                <span slot="off">Not Broker</span>
              </vs-switch>
            </div>
          </div>

          <cui-notice :person="data_local" />
          <div class="vx-row">
            <div class="vx-col md:w-4/12 w-full">
              <vs-input class="w-full mt-4" label="VAT Number" v-model="data_local.vat_number" @blur="onVatBlur"
                name="VAT Number" />
            </div>
            <div class="vx-col md:w-3/12 w-full">
              <vs-switch class="w-full mt-12" color="orange" icon-pack="feather" vs-icon-on="icon-yes"
                vs-icon-off="icon-no" v-model="data_local.subject_vat">
                <span slot="on">Applicable</span>
                <span slot="off">Not Applicable</span>
              </vs-switch>
            </div>

            <div class="vx-col md:w-5/12 w-full">
              <vs-alert class="w-full mt-10" :key="viesBadge.text" :color="viesBadge.color">
                <feather-icon :icon="viesBadge.icon" svgClasses="h-4 w-4" /> {{ viesBadge.text }}
              </vs-alert>
            </div>
          </div>
          <span class="text-sm" :class="viesNoteClass" v-if="viesNote">{{
            viesNote
          }}</span>
          <span class="text-danger text-sm" v-show="errors.has('vat')">{{
            errors.first("vat")
          }}</span>

          <vs-input class="w-full mt-4" label="Registration Number (J)" v-model="data_local.inmatriculare_j"
            name="Registration" />
          <div class="vx-row">
            <div class="vx-col md:w-1/2 w-full">
              <vs-input class="w-full mt-4" label="CUI / CNP" v-model="data_local.cui" name="CUI"
                placeholder="Company CUI, or CNP / national register number of a private person (digits only)"
                @blur="onCuiBlur" />
              <span class="text-grey text-sm">Private person: no VAT number. Leave VAT Number empty and enter
                their national register number (CNP) here — it is their fiscal code (cod fiscal) in SAGA.</span>
            </div>
            <div class="vx-col md:w-1/2 w-full">
              <vs-alert class="w-full mt-10" v-if="isAnafVatValid === 1" color="primary">
                <feather-icon icon="ThumbsUpIcon" svgClasses="h-4 w-4" /> ANAF → VAT registered (0%)
              </vs-alert>
              <vs-alert class="w-full mt-10" v-else-if="isAnafVatValid === 2" color="warning">
                <feather-icon icon="InfoIcon" svgClasses="h-4 w-4" /> ANAF → Not VAT registered (11%)
              </vs-alert>
              <vs-alert class="w-full mt-10" v-else-if="isAnafVatValid === 3" color="danger">
                <feather-icon icon="AlertCircleIcon" svgClasses="h-4 w-4" /> ANAF → Service unavailable
              </vs-alert>
              <vs-alert class="w-full mt-10" v-else-if="isAnafVatValid === 4" color="dark">
                <feather-icon icon="UserIcon" svgClasses="h-4 w-4" /> CNP → private person, no VAT number
              </vs-alert>
              <vs-alert class="w-full mt-10" v-else color="dark">
                <small><feather-icon icon="ZapOffIcon" svgClasses="h-4 w-4" /> Enter the CUI or CNP, then leave the field to check it</small>
              </vs-alert>
            </div>
          </div>
          <vs-input class="w-full mt-4" label="Bank Account" v-model="data_local.bank_account" type="Bank Account" />
          <!-- LANGUAGE -->
          <vs-select v-model="data_local.idlanguage" @change="getOptionsLanguages" label="Language" class="mt-4 w-full"
            name="language">
            <vs-select-item :key="item.id" :value="item.id" :text="item.name" v-for="item in data_options_languages" />
          </vs-select>
          <span class="text-danger text-sm" v-show="errors.has('language')">{{
            errors.first("language")
          }}</span>

          <div class="mt-4 w-full">
            <div class="flex items-center justify-between">
              <label class="text-sm font-medium text-gray-700">Contact Source</label>
              <vs-button v-if="displayExport" size="small" type="border" icon-pack="feather" icon="icon-settings"
                @click="openContactSourceManager" :disabled="isLoadingContactSources">Gestion</vs-button>
            </div>
            <v-select class="w-full mt-2" :options="contactSourceOptions" label="label"
              :reduce="option => option.id" v-model="data_local.idcontactsource" :disabled="isLoadingContactSources"
              :clearable="true" :loading="isLoadingContactSources"
              placeholder="Select contact source (optional)" @input="handleContactSourceChange" />
          </div>

          <vs-popup v-if="displayExport" title="Manage Contact Sources" :active.sync="isContactSourcePopupActive">
            <div class="mt-4">
              <vs-input class="w-full" label="New contact source" v-model="newContactSourceLabel"
                :disabled="isSavingContactSource" />
              <div class="mt-6">
                <p class="text-sm font-semibold mb-2">Existing sources</p>
                <div class="border rounded px-4 py-3 max-h-56 overflow-y-auto">
                  <div v-if="!contactSourceOptions.length" class="text-sm text-gray-600">
                    No contact sources available.
                  </div>
                  <div v-else class="existing-source-list">
                    <vs-radio v-for="option in contactSourceOptions" :key="option.id"
                      v-model="popupSelectedContactSourceId" :vs-value="option.id" class="existing-source-radio">
                      {{ option.label }}
                    </vs-radio>
                  </div>
                </div>
              </div>
              <div class="flex flex-wrap justify-end mt-4">
                <vs-button icon-pack="feather" icon="icon-plus" color="primary" type="border"
                  @click="handleAddContactSource" :disabled="!canCreateContactSource">Add</vs-button>
                <vs-button icon-pack="feather" icon="icon-trash" color="danger" type="border" class="ml-2"
                  @click="requestDeleteContactSource(popupSelectedContactSourceId)"
                  :disabled="!popupSelectedContactSourceId || isDeletingContactSource">Delete</vs-button>
              </div>
            </div>
          </vs-popup>

          <div class="vx-row mt-4">
            <div class="vx-col w-full">
              <span class="w-full" style="font-size:82%">
                &nbsp;&nbsp;Broker
              <v-select autocomplete :options="data_option_people_name" v-model="data_local.idbroker" :reduce="option => option.value" label="label" />
              </span>
            </div>
          </div>
        </div>
      </div>

      <div class="vx-col md:w-1/3 w-full">
        <p>
          <br />
          <vue-tel-input class="w-full mt-4" v-model="phone.number" :valid-characters-only="true"
            :preferred-countries="['be', 'fr', 'ro', 'de', 'nl']" @input="onInputPhone" />
          <!--<vs-input class="w-full mt-4" v-model="data_local.phone" name="Phone" />-->
          <span class="text-danger text-sm" v-show="errors.has('phone')">{{
            errors.first("phone")
          }}</span>
          <!--{{phone.valid}} {{phone.number}} -->
          <div class="w-full mt-6">
            <div class="flex items-center">
              <label class="vs-input--label" style="flex-shrink: 0;">Email for Invoices</label>
              <vx-tooltip text="This email will be used for invoices, payment reminders, credit notes and accounting documents." color="primary" position="right">
                <feather-icon icon="InfoIcon" svgClasses="h-4 w-4 ml-1 cursor-pointer text-primary" />
              </vx-tooltip>
            </div>
            <vs-input class="w-full" v-model="data_local.email" type="email" name="email1" />
          </div>
          <!--v-validate="'email'"-->
          <span class="text-danger text-sm" v-show="errors.has('email1')">{{
            errors.first("email1")
          }}</span>
          <div v-if="data_local.iscompany" class="w-full mt-4">
            <div class="flex items-center">
              <label class="vs-input--label" style="flex-shrink: 0;">Email for General</label>
              <vx-tooltip text="This email will be used for quotes, transport notifications and general communication." color="primary" position="right">
                <feather-icon icon="InfoIcon" svgClasses="h-4 w-4 ml-1 cursor-pointer text-primary" />
              </vx-tooltip>
            </div>
            <vs-input class="w-full" v-model="data_local.email_bis" type="email" name="email2" />
          </div>
          <!--v-validate="'email'"-->
          <span class="text-danger text-sm" v-show="errors.has('email2')">{{
            errors.first("email2")
          }}</span>

          <vs-input class="w-full mt-4" label="Website" v-model="data_local.website" />
          <vs-input v-if="data_local.isreseller" class="w-full mt-4" label="E-Shop" v-model="data_local.borker_eshop" />
        </p>
      </div>
      <div class="vx-col md:w-1/3 w-full">

          <!-- CLIENT TYPE -->
          <vs-select v-model="data_local.client_type" label="Client Type" class="mt-3 w-full" name="client_type">
            <vs-select-item :key="item.value" :value="item.value" :text="item.label" v-for="item in clientTypeOptions" />
          </vs-select>
          <span class="text-danger text-sm" v-show="errors.has('client_type')">{{
            errors.first("client_type")
          }}</span>


        <vs-input class="w-full mt-4" label="Payment deadline (in days)" v-model="data_local.payment_due_day"
          name="deadline" v-validate="'integer'" />
        <span class="text-danger text-sm" v-show="errors.has('deadline')">{{
          errors.first("deadline")
        }}</span>
        <vs-input class="w-full mt-4" label="Reference Price (EUR/m3)" v-model="data_local.ref_price" name="price"
          v-validate="'decimal'" />
        <span class="text-danger text-sm" v-show="errors.has('price')">{{
          errors.first("price")
        }}</span>
        <vs-textarea class="w-full mt-10" counter="200" label="Interest" :counter-danger.sync="counterDanger"
          v-model="data_local.product_interest" />
        <br />

        <div class="vx-row">
          <div class="vx-col md:w-1/2 w-full">
            <h6>Sanity Check</h6>
            <ul class="centerx">
              <li>
                <vs-radio color="warning" v-model="radioSanityCheck" vs-value="null">To be checked</vs-radio>
              </li>
              <li>
                <vs-radio color="danger" v-model="radioSanityCheck" vs-value="false">Danger</vs-radio>
              </li>
              <li>
                <vs-radio color="success" v-model="radioSanityCheck" vs-value="true">Good</vs-radio>
              </li>
            </ul>
          </div>
          <div class="vx-col md:w-1/2 w-full" v-if="radioSanityCheck != 'null'">
            <vs-input class="w-full mt-0" label="Check date" v-model="data_local.birthday" type="date"
              name="birthday" />
          </div>
        </div>
        <br />
        <!-- Cote credit, en LECTURE SEULE.
             Elle n'est pas une colonne de people : elle vit dans sa propre
             table, historisee, et n'est donc pas ecrite par ce formulaire. La
             poser a la main est un geste delibere et commente, depuis la fiche
             contact, pas un champ qu'on traverse en corrigeant un telephone. -->
        <h6>Credit rating</h6>
        <div class="mt-1 mb-4">
          <vs-chip :color="creditColor">{{ creditLabel }}</vs-chip>
          <span class="text-sm ml-2 opacity-75">
            {{ creditSummary }} Read-only here — the full picture is on the contact page.
          </span>
        </div>

        <h6>Reliability</h6>
        <star-rating :star-size="20" v-model="data_local.reliability"></star-rating>
      </div>
    </div>
    <br />
    <br />
    <template>
      <div id="data-list-list-view" class="data-list-container">
        <data-view-sidebar :isSidebarActive="addNewDataSidebar" @closeSidebar="toggleDataSidebar" :data="sidebarData" />

        <vs-table ref="table" :data="addresses">
          <div slot="header" class="
              flex flex-wrap-reverse
              items-center
              flex-grow
              justify-between
            ">
            <div class="
                flex flex-wrap-reverse
                items-center
                data-list-btn-container
              ">
              <div class="
                  btn-add-new
                  p-3
                  mb-4
                  mr-4
                  rounded-lg
                  cursor-pointer
                  flex
                  items-center
                  justify-center
                  text-lg
                  font-medium
                  text-base text-primary
                  border border-solid border-primary
                " @click="addNewData">
                <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" />
                <span class="ml-2 text-base text-primary">Add Address</span>
              </div>
            </div>
          </div>

          <template slot="thead">
            <vs-th sort-key="username">Type</vs-th>
            <vs-th sort-key="username">Country</vs-th>
            <vs-th sort-key="email">Region</vs-th>
            <vs-th sort-key="firstname">Postal</vs-th>
            <vs-th sort-key="lastname">Place</vs-th>
            <vs-th sort-key="active">Street</vs-th>
            <vs-th sort-key="active">Number</vs-th>
            <vs-th sort-key="active">Default</vs-th>
            <vs-th>Action</vs-th>
          </template>

          <template slot-scope="{ data }">
            <tbody>
              <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                <vs-td>
                  <p class="font-medium truncate">
                    {{ tr.addresscategory.name_en }}
                  </p>
                </vs-td>

                <vs-td>
                  <p class="font-medium truncate">
                    {{ tr.place.country.name_en }}
                  </p>
                </vs-td>

                <vs-td>
                  <p v-if="tr.place.province">
                    {{ tr.place.region }}/{{ tr.place.province }}
                  </p>
                  <p v-else>{{ tr.place.region }}</p>
                </vs-td>

                <vs-td>
                  <p>{{ tr.place.postal_code }}</p>
                </vs-td>

                <vs-td>
                  <p>{{ tr.place.place_name }}</p>
                </vs-td>

                <vs-td>
                  <p>{{ tr.street }}</p>
                </vs-td>
                <vs-td>
                  <p>{{ tr.number }}</p>
                </vs-td>
                <vs-td>
                  <p>{{ tr.isdefault ? 'Yes' : 'No' }}</p>
                </vs-td>


                <vs-td class="whitespace-no-wrap">
                  <feather-icon icon="EditIcon" svgClasses="w-5 h-5 hover:text-primary stroke-current"
                    @click.stop="editData(tr)" />
                  <feather-icon icon="TrashIcon" svgClasses="w-5 h-5 hover:text-danger stroke-current" class="ml-2"
                    @click.stop="deleteAddressOne(tr.id, tr.place.place_name)" />
                </vs-td>
              </vs-tr>
            </tbody>
          </template>
        </vs-table>
      </div>
    </template>
    <div class="vx-row">
      <div class="vx-col w-full">
        <div v-if="data_local.id" class="mt-8 flex flex-wrap items-center justify-end">
          <vs-button v-if="data_local.isactive && displayExport != false" type="border" color="danger"
            icon-pack="feather" icon="icon-trash" @click="confirmDeleteRecord">Disable</vs-button>
          <vs-button v-else-if="displayExport != false" type="border" color="success" icon-pack="feather" icon="icon-trash"
            @click="confirmEnableRecord">Enable</vs-button>

          <vs-button class="ml-auto" color="success" @click="save_changes" :disabled="!validateForm || isSaving">Save
            Changes</vs-button>
        </div>
        <div v-else class="mt-8 flex flex-wrap items-center justify-end">
          <vs-button class="ml-auto" color="success" @click="save_changes" :disabled="!validateForm || isSaving">Add</vs-button>
        </div>
        <br />
      </div>
    </div>
  </div>
</template>
<script>
import DataViewSidebar from "./DataViewSidebar.vue";
import CuiNotice from "@/components/efactura/CuiNotice.vue";
import modulePersonList from "@/store/people/modulePersonList.js";
import vSelect from "vue-select";
import axios from "@/axios.js";
import { takePersonOption } from "@/helpers/personOption";
import StarRating from "vue-star-rating";
import { VueTelInput } from "vue-tel-input";
import pricingZones from "@/mixins/pricingZones";
import creditRating from "@/mixins/creditRating";
import viesCheck from "@/mixins/viesCheck.js";
export default {
  mixins: [pricingZones, creditRating, viesCheck],
  components: {
    DataViewSidebar,
    vSelect,
    VueTelInput,
    StarRating,
    CuiNotice,
  },
  props: {
    data: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      isSaving: false,
      creditRating: null,
      isAnafVatValid: 0,
      displayExport: false,
      data_option_people_name: [],
      personId: null,
      data_options_languages: [],
      data_options_company: [],
      contactSourceOptions: [],
      newContactSourceLabel: "",
      isLoadingContactSources: false,
      isSavingContactSource: false,
      isDeletingContactSource: false,
      isContactSourcePopupActive: false,
      popupSelectedContactSourceId: null,
      // clientTypeOptions is now provided by the pricingZones mixin (dynamic incoterms).
      data_local: JSON.parse(JSON.stringify(this.data)),
      selected: [],
      isMounted: false,
      addNewDataSidebar: false,
      sidebarData: {},
      buttonSubmitOpen: false,
      state: {},
      counterDanger: false,
      radioSanityCheck: null,
      phone: {
        number: "",
        valid: false,
        country: undefined,
      },
    };
  },
  computed: {
    addresses() {
      return this.$store.state.peopleList.addresses;
    },
    validateForm() {
      return (
        !this.errors.any() &&
        !this.counterDanger &&
        ((this.data_local.firstname && this.data_local.lastname) ||
          this.data_local.company_name)
      );
    },
    currentPage() {
      if (this.isMounted) {
        if (this.data_local.id) return this.$refs.table.currentx;
      }
      return 0;
    },
    queriedItems() {
      if (this.data_local.id)
        return this.$refs.table
          ? this.$refs.table.queriedResults.length
          : this.users.length;
    },
    canCreateContactSource() {
      return (
        !!this.newContactSourceLabel &&
        this.newContactSourceLabel.trim().length > 0 &&
        !this.isSavingContactSource
      );
    },
    canDeleteContactSource() {
      return !!this.data_local.idcontactsource && !this.isDeletingContactSource;
    },
  },
  methods: {
    // Lecture seule : la cote n'entre PAS dans le payload de save_changes().
    async getCreditRating() {
      const id = this.$route.params.userId;
      if (!id) return;
      axios
        .get("/person/creditrating/" + id)
        .then((response) => {
          this.creditRating = response.data.current;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    onInputPhone(formattedNumber, { number, valid, country }) {
      this.phone.number = number.international;
      this.phone.valid = valid;
      this.phone.country = country && country.name;
    },
    countryCodeFromName(name) {
      if (!name) return null;
      const map = {
        romania: "RO", belgium: "BE", france: "FR", germany: "DE",
        netherlands: "NL", italy: "IT", spain: "ES", luxembourg: "LU",
        austria: "AT", bulgaria: "BG", croatia: "HR", cyprus: "CY",
        "czech republic": "CZ", czechia: "CZ", denmark: "DK", estonia: "EE",
        finland: "FI", greece: "EL", hungary: "HU", ireland: "IE",
        latvia: "LV", lithuania: "LT", malta: "MT", poland: "PL",
        portugal: "PT", slovakia: "SK", slovenia: "SI", sweden: "SE",
        "united kingdom": "GB", "great britain": "GB",
      };
      return map[String(name).trim().toLowerCase()] || null;
    },
    deriveCountryPrefix() {
      if (this.data_local.cui && String(this.data_local.cui).trim()) return "RO";
      if (Array.isArray(this.addresses) && this.addresses.length > 0) {
        const country = this.addresses[0].place && this.addresses[0].place.country;
        if (country) {
          if (country.iso_code) return String(country.iso_code).toUpperCase();
          return this.countryCodeFromName(country.name_en);
        }
      }
      return null;
    },
    normalizeCui() {
      if (!this.data_local.cui) return;
      let val = String(this.data_local.cui).trim().toUpperCase();
      val = val.replace(/^[A-Z]{2}/, "");
      val = val.replace(/\D/g, "");
      this.data_local.cui = val;
    },
    normalizeVat() {
      if (!this.data_local.vat_number) return;
      let val = String(this.data_local.vat_number).trim().toUpperCase().replace(/\s+/g, "");
      if (!/^[A-Z]{2}/.test(val)) {
        const prefix = this.deriveCountryPrefix();
        if (prefix) val = prefix + val;
      }
      this.data_local.vat_number = val;
    },
    onCuiBlur() {
      this.normalizeCui();
      this.checkAnafVat();
    },
    onVatBlur() {
      // 13 chiffres = un CNP, pas un numéro de TVA : la fiche le dit et le range
      // dans CUI / CNP (mixin viesCheck) ; avant normalizeVat, qui lui collerait un RO.
      if (this.moveCnpOutOfVat()) return;
      this.normalizeVat();
      this.checkVies(this.data_local.vat_number);
    },
    async checkAnafVat() {
      const raw = (this.data_local.cui && String(this.data_local.cui).trim()) || "";
      const digits = raw.replace(/\D/g, "");
      if (digits.length < 8 || digits.length > 13) {
        this.isAnafVatValid = 0;
        return;
      }
      // 13 chiffres = CNP d'une personne physique (un CUI en a au plus 10) : pas
      // d'assujettissement à demander à l'ANAF, pas de numéro de TVA.
      if (digits.length === 13) {
        this.isAnafVatValid = 4;
        this.data_local.subject_vat = false;
        return;
      }
      try {
        const response = await axios.get("/anaf-vat-check/" + encodeURIComponent(digits));
        if (response.data.vatValid) {
          this.isAnafVatValid = 1;
          this.data_local.vat_number = response.data.vatNumber || "RO" + digits;
          this.data_local.subject_vat = true;
          this.checkVies(this.data_local.vat_number);
        } else {
          this.isAnafVatValid = 2;
          this.data_local.subject_vat = false;
        }
      } catch (err) {
        this.isAnafVatValid = 3;
        console.error("ANAF check error:", err);
      }
    },
    async getPeople() {
      axios.get("/people_name/data").then((response) => {
        this.data_option_people_name = [...response.data];
        // Le contact du document, même inactif — jamais le dernier de la liste (helpers/personOption).
        this.personId = takePersonOption(this.data_option_people_name, this.operation_data.people[0]);
      });
    },
    async getOptionsLanguages() {
      axios.get("/languageslist").then((response) => {
        this.data_options_languages = [...response.data];
      });
    },
    async fetchContactSources() {
      this.isLoadingContactSources = true;
      try {
        const response = await axios.get("/contact-sources");
        const options = Array.isArray(response.data)
          ? response.data.map((source) => ({
            id: source.id,
            label: source.label,
          }))
          : [];
        this.contactSourceOptions = options;
        this.ensureSelectedContactSourceOption();
      } catch (error) {
        console.error(error);
        this.$vs.notify({
          color: "danger",
          title: "Contact Source",
          text: "Unable to load contact sources.",
        });
      } finally {
        this.syncSelectedContactSource(this.data_local.idcontactsource);
        this.isLoadingContactSources = false;
      }
    },
    ensureSelectedContactSourceOption() {
      if (!this.data_local.idcontactsource) {
        return;
      }
      const exists = this.contactSourceOptions.some(
        (option) => option.id === this.data_local.idcontactsource
      );
      if (!exists && this.data_local.contactsource) {
        this.contactSourceOptions.push({
          id: this.data_local.contactsource.id,
          label: this.data_local.contactsource.label,
        });
      }
      this.contactSourceOptions.sort((a, b) =>
        a.label.localeCompare(b.label)
      );
    },
    syncSelectedContactSource(id) {
      if (id === null || id === undefined || id === "") {
        this.data_local.contactsource = null;
        this.popupSelectedContactSourceId = null;
        return;
      }
      let option = this.contactSourceOptions.find(
        (item) => String(item.id) === String(id)
      );
      if (!option && this.data_local.contactsource && String(this.data_local.contactsource.id) === String(id)) {
        option = this.data_local.contactsource;
      }
      if (option) {
        this.data_local.contactsource = option;
        this.popupSelectedContactSourceId = option.id;
      } else {
        this.data_local.contactsource = null;
        this.popupSelectedContactSourceId = null;
      }
    },
    handleContactSourceChange(value) {
      if (value === null || value === undefined || value === "") {
        this.data_local.idcontactsource = null;
        this.data_local.contactsource = null;
        this.popupSelectedContactSourceId = null;
        return;
      }
      this.syncSelectedContactSource(value);
    },
    async handleAddContactSource() {
      if (!this.canCreateContactSource) {
        return;
      }
      const label = this.newContactSourceLabel.trim();
      this.isSavingContactSource = true;
      try {
        const response = await axios.post("/contact-sources", { label });
        const option = {
          id: response.data.id,
          label: response.data.label,
        };
        this.contactSourceOptions.push(option);
        this.contactSourceOptions.sort((a, b) =>
          a.label.localeCompare(b.label)
        );
        this.data_local.idcontactsource = option.id;
        this.newContactSourceLabel = "";
        this.syncSelectedContactSource(option.id);
        this.$vs.notify({
          color: "success",
          title: "Contact Source",
          text: "Source added successfully.",
        });
      } catch (error) {
        if (error.response && error.response.status === 409) {
          this.$vs.notify({
            color: "warning",
            title: "Contact Source",
            text: "This source already exists.",
          });
        } else {
          this.$vs.notify({
            color: "danger",
            title: "Contact Source",
            text: "Unable to add the source.",
          });
        }
      } finally {
        this.isSavingContactSource = false;
      }
    },
    requestDeleteContactSource(sourceId = this.data_local.idcontactsource) {
      if (!sourceId || this.isDeletingContactSource) {
        return;
      }
      const option = this.contactSourceOptions.find(
        (item) => item.id === sourceId
      );
      const label = option ? option.label : "this source";
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: "Delete contact source",
        text: `You are about to delete "${label}".`,
        acceptText: "Delete",
        accept: () => this.performDeleteContactSource(sourceId),
      });
    },
    async performDeleteContactSource(sourceId) {
      if (!sourceId) {
        return;
      }
      this.isDeletingContactSource = true;
      try {
        await axios.delete(`/contact-sources/${sourceId}`);
        this.contactSourceOptions = this.contactSourceOptions.filter(
          (option) => option.id !== sourceId
        );
        if (this.data_local.idcontactsource === sourceId) {
          this.data_local.idcontactsource = null;
          this.data_local.contactsource = null;
        }
        this.syncSelectedContactSource(this.data_local.idcontactsource);
        this.$vs.notify({
          color: "success",
          title: "Contact Source",
          text: "Source deleted.",
        });
      } catch (error) {
        console.error(error);
        this.$vs.notify({
          color: "danger",
          title: "Contact Source",
          text: "Unable to delete the source.",
        });
      } finally {
        this.isDeletingContactSource = false;
      }
    },
    openContactSourceManager() {
      if (this.data_local.idcontactsource) {
        this.popupSelectedContactSourceId = this.data_local.idcontactsource;
      } else {
        this.popupSelectedContactSourceId = null;
      }
      this.isContactSourcePopupActive = true;
    },
    manageSanityCheck() {
      if (this.data_local.issanator === true) {
        this.radioSanityCheck = "true";
      } else if (this.data_local.issanator === false) {
        this.radioSanityCheck = "false";
      } else {
        this.radioSanityCheck = "null";
      }
    },
    /*async getCompany() {
      axios.get("/company/data").then((response) => {
        this.data_options_company = [...response.data];
        if (this.data_local.idcompany) {
          const ItemIndex = this.data_options_company.findIndex(
            (p) => p.value === this.data_local.idcompany
          );
          this.data_local.idcompany = this.data_options_company.splice(
            ItemIndex,
            1
          );
        }
      });
    },*/
    confirmDeleteRecord() {
      let namealert = null;
      if (!this.data_local.company_name)
        namealert = this.data_local.firstname + " " + this.data_local.lastname;
      else namealert = this.data_local.company_name;
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: "Confirm Disable",
        text: `You are about to disable ${namealert}`,
        accept: this.deleteRecord,
        acceptText: "Disable",
      });
    },
    confirmEnableRecord() {
      let namealert = null;
      if (!this.data_local.company_name)
        namealert = this.data_local.firstname + " " + this.data_local.lastname;
      else namealert = this.data_local.company_name;
      this.$vs.dialog({
        type: "confirm",
        color: "success",
        title: "Confirm Enable",
        text: `You are about to re-enable ${namealert}`,
        accept: this.enableRecord,
        acceptText: "Enable",
      });
    },
    enableRecord() {
      axios
        .post("/person/enable", { id: this.data_local.id })
        .catch((err) => {
          // `resolve` n'existe pas ici : ReferenceError avalee, echec invisible.
          console.error("user account:", err);
          const data = err && err.response && err.response.data;
          this.$vs.notify({
            color: "danger",
            title: "NOT saved",
            text: (data && (data.message || data.error)) || (err && err.message) ||
              "The server refused the change.",
            time: 12000,
          });
        });
      this.$router.push({ path: "/person/" + this.data_local.id });
      this.showEnableSuccess();
    },
    showEnableSuccess() {
      this.$vs.notify({
        color: "success",
        title: "Person Enable",
        text: "The selected person was successfully enabled",
      });
    },
    deleteRecord() {
      axios
        .post("/person/disable", { id: this.data_local.id })
        .catch((err) => {
          // `resolve` n'existe pas ici : ReferenceError avalee, echec invisible.
          console.error("user account:", err);
          const data = err && err.response && err.response.data;
          this.$vs.notify({
            color: "danger",
            title: "NOT saved",
            text: (data && (data.message || data.error)) || (err && err.message) ||
              "The server refused the change.",
            time: 12000,
          });
        });
      this.$router.push({ path: "/person/" + this.data_local.id });
      this.showDeleteSuccess();
    },
    showDeleteSuccess() {
      this.$vs.notify({
        color: "success",
        title: "Person Deleted",
        text: "The selected person was successfully deleted",
      });
    },
    capitalize(str) {
      return str.slice(0, 1).toUpperCase() + str.slice(1, str.length);
    },
    async save_changes() {
      if (this.isSaving) return;
      var _issanator = null;
      if (this.radioSanityCheck === "true") _issanator = true;
      else if (this.radioSanityCheck === "false") _issanator = false;

      var iscompany = false;
      if (this.data_local.iscompany) iscompany = true;
      else iscompany = false;
      var _idcompany = null;
      if (this.data_local.idcompany)
        _idcompany = this.data_local.idcompany.value;

      const obj = {
        id: this.data_local.id,
        iscompany: iscompany,
        company_name: this.data_local.company_name,
        vat_number: this.data_local.vat_number,
        cui: this.data_local.cui,
        email: this.data_local.email ? this.data_local.email.replace(/,/g, ';') : this.data_local.email,
        email_bis: this.data_local.email_bis ? this.data_local.email_bis.replace(/,/g, ';') : this.data_local.email_bis,
        website: this.data_local.website,
        bank_account: this.data_local.bank_account,
        ref_price: this.data_local.ref_price,
        product_interest: this.data_local.product_interest,
        phone: this.phone.number,
        idlanguage: this.data_local.idlanguage,
        lastname: this.data_local.lastname,
        firstname: this.data_local.firstname,
        birthday: this.data_local.birthday,
        reliability: this.data_local.reliability,
        subject_vat: this.data_local.subject_vat,
        isreseller: this.data_local.isreseller,
        isbroker: this.data_local.isbroker,
        borker_eshop: this.data_local.borker_eshop,
        payment_due_day: this.data_local.payment_due_day,
        idcompany: _idcompany,
        isactive: true,
        issanator: _issanator,
        inmatriculare_j: this.data_local.inmatriculare_j,
        idbroker: this.data_local.idbroker,
        client_type: this.data_local.client_type,
        idcontactsource: this.data_local.idcontactsource,
      };
      if (!this.data_local.id) return;
      // On ATTEND la réponse : le serveur peut refuser la fiche (numéro de TVA que
      // VIES ne valide pas). Avant, « Person Updated! » s'affichait et l'écran
      // changeait de page dans tous les cas, refus compris.
      this.isSaving = true;
      this.$vs.loading();
      let failure = null;
      try {
        await this.$store.dispatch("peopleList/updatePerson", obj);
      } catch (err) {
        failure = err || new Error("unknown");
      }
      this.$vs.loading.close();
      this.isSaving = false;
      if (failure) {
        this.showContactSaveFailure(failure);
        return;
      }
      this.$router.push({ name: "people/person-view" });

      this.$vs.notify({
        color: "success",
        title: "Person Updated!",
        text: "The person was successfully updated",
      });
    },
    addNewData() {
      if (this.data_local.id) {
        var idperson = this.data_local.id;
        let nbofaddress = this.addresses.length;
        this.sidebarData = { idperson, nbofaddress };
        this.toggleDataSidebar(true);
      } else {
        this.$vs.notify({
          color: "warning",
          title: "Please Add Person",
          text: "You have to add person before adding new address",
        });
      }
    },
    showDeleteAddressSuccess() {
      this.$vs.notify({
        color: "success",
        title: "Address Deleted",
        text: "The address was successfully deleted",
      });
    },
    deleteAddress(id) {
      const obj = {
        idaddress: this.addresstodelete,
        idperson: this.data_local.id,
      };
      if (!modulePersonList.isRegistered) {
        this.$store.registerModule("peopleList", modulePersonList);
        modulePersonList.isRegistered = true;
      }
      this.$store.dispatch("peopleList/removeAddress", obj).catch((err) => {
        console.error(err);
      });
      this.showDeleteAddressSuccess();
    },
    deleteAddressOne(id, place) {
      this.addresstodelete = id;
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: "Confirm Delete",
        text: `You are about to delete the address ${place}`,
        accept: this.deleteAddress,
        acceptText: "Delete Address",
      });
    },
    editData(data) {
      data.idperson = this.data_local.id;
      this.sidebarData = data;
      this.toggleDataSidebar(true);
    },
    getActiveColors(status) {
      if (status === "true") return "primary";
      if (status === false) return "danger";
      return "warning";
    },
    toggleDataSidebar(val = false) {
      this.addNewDataSidebar = val;
    },
    fetch_addresses_data(userId) {
      if (userId) {
        this.$store
          .dispatch("peopleList/fetchAddresses", userId)
          .then((response) => {
            this.normalizeVat();
            this.checkVies(this.data_local.vat_number);
            this.$vs.loading.close();
          });
      }
    },
  },
  mounted() {
    this.isMounted = true;
  },
  created() {
    this.$vs.loading();
    //this.getCompany();
    this.normalizeCui();
    this.getPeople();
    this.fetch_addresses_data(this.$route.params.userId);
    this.manageSanityCheck();
    this.getOptionsLanguages();
    this.phone.number = this.data_local.phone;
    if (this.data_local.contactsource && !this.data_local.idcontactsource) {
      this.data_local.idcontactsource = this.data_local.contactsource.id;
    }
    this.fetchContactSources();
    this.getCreditRating();
    if (localStorage.getItem("login-roles").toLowerCase().includes("admin")) {
      this.displayExport = true;
    }
  },
};
</script>

<style scoped>
.existing-source-list {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.existing-source-radio {
  display: flex;
  align-items: center;
}
</style>
